export class PaymentsContextDto {
  owner: {
    showedStep: number;
    currentStep: number;
    hasRegisteredWithStripe: boolean;
    hasResumedRenting: boolean;
  } = { showedStep: 1, currentStep: 1, hasRegisteredWithStripe: false, hasResumedRenting: false };
  tenant: {
    showedStep: number;
    currentStep: number;
    hasPaidFee: boolean;
    hasPaidDeposit: boolean;
    hasStartedSubscription: boolean;
  } = { showedStep: 1, currentStep: 1, hasPaidFee: false, hasPaidDeposit: false, hasStartedSubscription: false };

  constructor(anotherObject: PaymentsContextDto | null = null) {
    Object.assign(this, anotherObject);
  }
}
